import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { InputText } from 'primereact/inputtext'
import {
  CustomModal,
  Btn,
  InputNumeroDecimal,
  OcorrenciasDropdown,
  UploadMultFileBtn,
} from '../../../../../../components'
import { tableCellCentered } from '../../../../../../assets/js/styles'
import { hideLoadingBox, showMessageBox } from '../../../../../../store/actions/system.actions'
import useModalApontamentoFaltaManual, { LOAD_MESSAGE } from './ModalApontamentoFaltaManualHook'
import {
  urlFotosFalta,
  urlUploadFotoFalta,
} from '../../../../../../services/api/routes/picking.routes'
import ModalFotosOcorrencias from '../../ModalFotosOcorrencias/ModalFotosOcorrencias'

function ModalApontamentoFaltaManual({
  dispatch,
  selectedPicking,
  onModalSave,
  data,
  show,
  onModalClose,
}) {
  const { state, localDispatch } = useModalApontamentoFaltaManual()

  useEffect(() => {
    if (show) localDispatch.onInit(data, selectedPicking)
  }, [show, data.items])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.SAVE_MISSINGS:
        onModalSave()
        break

      case LOAD_MESSAGE.FILE_UPLOADED:
        localDispatch.onBtnSalvarClicked(state.items, selectedPicking)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  const header = (
    <div style={{ textAlign: 'left' }}>
      <i className="pi pi-search" style={{ margin: '4px 4px 0 0' }}></i>
      <InputText
        value={state.globalFilter}
        onChange={e => localDispatch.onGlobalFilterChange(e.target.value)}
        placeholder="Pesquisar . . ."
        size="50"
      />
    </div>
  )

  const showColumnIdentificador = () => {
    if (state.items.length > 0 && state.items[0].identifier)
      return <Column field="identifier" style={tableCellCentered(110)} header="Identificador" />
  }

  return (
    <CustomModal
      header="Apontamento das Faltas"
      isVisible={show}
      onClose={onModalClose}
      maximizable={true}
      width="95vw"
      contentStyle={{ height: '90vh', overflow: 'auto' }}
    >
      <div className="p-grid">
        <div className="p-col-2">
          <Btn onClick={() => localDispatch.onBtnSalvarClicked(state.items, selectedPicking)}>
            Salvar
          </Btn>
        </div>
        <div className="p-col-12">
          <span style={{ fontWeight: 'bold' }}>
            * Selecione a ocorrência, informe a quantidade de faltas e salve para poder salvar
            fotos.
          </span>
        </div>
      </div>
      <DataTable
        value={state.items}
        paginator={true}
        rows={5}
        header={header}
        globalFilter={state.globalFilter}
        className="auto-layout"
      >
        {showColumnIdentificador()}
        <Column field="product_code" style={tableCellCentered(200)} header="Código" />
        <Column field="product_name" header="Produto" />
        <Column field="qte_sku" header="Qte." style={tableCellCentered(60)} />
        <Column
          header="Ocorrência"
          body={item => (
            <OcorrenciasDropdown
              disabled={state.btnSalvarDisabled}
              style={{ width: '100%' }}
              optionLabel="name"
              value={item.missing_reason}
              options={data.ocorrencias}
              onChange={({ value }) => localDispatch.onDropdownChange(item, value)}
            />
          )}
        />
        <Column
          header="Qte Faltas"
          style={tableCellCentered(100)}
          body={item => (
            <InputNumeroDecimal
              marginTop={0}
              showLabel={false}
              value={item.qte_missing_produto}
              onChange={value => localDispatch.onFaltaInputChange(item, value)}
              width={80}
            />
          )}
        />

        <Column
          header="Fotos"
          body={item => (
            <Btn
              onClick={() => localDispatch.onVerFotosClicked(item)}
              disabled={!item.files.length}
            >
              Ver Fotos ({item.files.length})
            </Btn>
          )}
          style={tableCellCentered(120)}
        />
        <Column
          header=""
          style={tableCellCentered(160)}
          body={item => {
            let disabled = true

            const entrega = state.selectedEntrega
            if (entrega && entrega.items) {
              const itemSelected = entrega.items.find(
                i => i.delivery_item_id === item.delivery_item_id,
              )

              disabled = !(itemSelected.missing_reason && itemSelected.qte_missing_produto)
            }

            return (
              <div style={{ position: 'relative', top: '-20px' }}>
                <UploadMultFileBtn
                  label="Anexar Fotos"
                  name="faltas"
                  accept="image/*"
                  disabled={disabled}
                  url={urlUploadFotoFalta()}
                  onUploadCompleted={file_name => localDispatch.onUploadCompleted(file_name, item)}
                />
              </div>
            )
          }}
        />
      </DataTable>
      <ModalFotosOcorrencias
        show={state.modal.show}
        onModalClose={localDispatch.onModalClose}
        data={state.modal.data}
        selectedPicking={selectedPicking}
        onDelete={localDispatch.onDeleteFoto}
        urlFoto={urlFotosFalta}
      />
    </CustomModal>
  )
}

const mapStateToProps = ({ picking: { selectedPicking } }) => ({ selectedPicking })
export default connect(mapStateToProps)(ModalApontamentoFaltaManual)
